import * as React from 'react';
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

interface ConfirmDialogProps {
  isOpen?: boolean;
  toggle?: () => void;
  onConfirm: () => any;
  header?: string;
  body?: React.ReactNode;
  confirmButtonText?: string;
  confirmButtonColor?: string;
  cancelButtonText?: string;
  cancelButtonColor?: string;
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    isOpen,
    toggle,
    onConfirm,
    header,
    body,
    confirmButtonText,
    confirmButtonColor,
    cancelButtonText,
    cancelButtonColor,
  } = props;

  return (
    <Modal isOpen={!!isOpen} toggle={toggle}>
      <Form>
        <ModalHeader>{header ?? 'Confirm action'}</ModalHeader>
        <ModalBody>{body ?? <div>Click {confirmButtonText ?? 'OK'} to continue.</div>}</ModalBody>
        <ModalFooter>
          <Button color={confirmButtonColor ?? 'primary'} onClick={onConfirm}>
            {confirmButtonText ?? 'OK'}
          </Button>
          <Button color={cancelButtonColor ?? 'light'} onClick={toggle}>
            {cancelButtonText ?? 'Cancel'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ConfirmDialog;
